/**
 * Utility to handle ResizeObserver errors
 * Suppresses "ResizeObserver loop completed with undelivered notifications" warnings
 */

// Store the original error handler
const originalErrorHandler = window.onerror;

/**
 * Initialize ResizeObserver error handler
 * This suppresses the common ResizeObserver loop warning while preserving other errors
 */
export const initializeResizeObserverErrorHandler = () => {
  // Handle window errors
  window.onerror = (message, source, lineno, colno, error) => {
    // Check if this is a ResizeObserver error
    if (
      typeof message === 'string' && message.includes('ResizeObserver loop completed with undelivered notifications')
    ) {
      // Suppress the ResizeObserver error
      return true;
    }
    
    // Call original error handler for other errors
    if (originalErrorHandler) {
      return originalErrorHandler(message, source, lineno, colno, error);
    }
    
    return false;
  };

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    // Check if this is a ResizeObserver error
    if (
      event.reason &&
      event.reason.message &&
      event.reason.message.includes('ResizeObserver loop completed with undelivered notifications')
    ) {
      // Suppress the ResizeObserver error
      event.preventDefault();
    }
  });

  // Handle console errors (for development)
  if (process.env.NODE_ENV === 'development') {
    const originalConsoleError = console.error;
    console.error = (...args) => {
      // Check if this is a ResizeObserver error
      if (
        args.length > 0 &&
        typeof args[0] === 'string' &&
        args[0].includes('ResizeObserver loop completed with undelivered notifications')
      ) {
        // Suppress the ResizeObserver error in development
        return;
      }
      
      // Call original console.error for other errors
      originalConsoleError.apply(console, args);
    };
  }
};

/**
 * Cleanup function to restore original error handlers
 */
export const cleanupResizeObserverErrorHandler = () => {
  window.onerror = originalErrorHandler;
};